import Lenis from '@theme/lenis';

const finePointer = window.matchMedia('(pointer: fine)');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

let lenis = null;

function start() {
  if (lenis || window.Shopify?.designMode || !finePointer.matches || reducedMotion.matches) return;

  lenis = new Lenis({
    lerp: 0.18,
    smoothWheel: false,
    syncTouch: false,
    anchors: true,
    autoRaf: true,
    prevent: (node) => Boolean(node.closest('dialog, [popover], [data-lenis-prevent]')),
  });

  window.lenis = lenis;

  if (document.documentElement.hasAttribute('scroll-lock')) {
    lenis.stop();
  }
}

function stop() {
  if (!lenis) return;
  lenis.destroy();
  lenis = null;
  window.lenis = null;
}

function refresh() {
  stop();
  start();
}

finePointer.addEventListener('change', refresh);
reducedMotion.addEventListener('change', refresh);

new MutationObserver(() => {
  if (!lenis) return;
  if (document.documentElement.hasAttribute('scroll-lock')) {
    lenis.stop();
  } else {
    lenis.start();
  }
}).observe(document.documentElement, { attributes: true, attributeFilter: ['scroll-lock'] });

start();